export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          漫友热评
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          来自刃牙漫画读者的真实声音
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <span className="text-primary-600 font-heading text-sm">格</span>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-900">格斗迷阿强</div>
                <div className="text-xs text-foreground-400">刃牙老粉·3年</div>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">刃牙漫画下拉式全集真的太方便了！不用一直点翻页，一路滑下来看刃牙VS勇次郎的战斗，爽到飞起。刃牙漫画在线看体验绝对是目前最好的。</p>
            <div className="flex items-center gap-3 mt-4 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> 326</span>
              <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 58</span>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <span className="text-accent-600 font-heading text-sm">漫</span>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-900">漫画收藏家</div>
                <div className="text-xs text-foreground-400">资深漫友·5年</div>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">找了很久刃牙漫画全集，终于在这个站找到了完整版。刃牙漫画在线阅读画质超清，翻译也很到位。墙裂推荐给所有刃牙漫画在线观看的漫友！</p>
            <div className="flex items-center gap-3 mt-4 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> 251</span>
              <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 42</span>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
                <span className="text-secondary-600 font-heading text-sm">夜</span>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-900">夜读人小林</div>
                <div className="text-xs text-foreground-400">新入坑·1年</div>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">最近才开始看刃牙，刃牙漫画免费在线太适合我这种学生党了。不用下载APP，手机浏览器打开就能刃牙漫画在线看，课间刷几话超方便。</p>
            <div className="flex items-center gap-3 mt-4 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> 189</span>
              <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 35</span>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <span className="text-primary-600 font-heading text-sm">拳</span>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-900">拳拳到肉</div>
                <div className="text-xs text-foreground-400">格斗漫达人·4年</div>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">刃牙漫画免费在线阅读这个站做得真心好，高清画质连板垣恵介老师的每一根肌肉线条都看得清清楚楚。刃牙漫画下拉式全集排版太适合连续阅读了！</p>
            <div className="flex items-center gap-3 mt-4 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> 412</span>
              <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 73</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}